export default "__VITE_ASSET__8a5864c3__"